/**
 * Enums used for Free Text group search
 */
export default {
  REGION: 'region',
  POSTCODE: 'postcode',
  UNKNOWN: 'unknown',
  PLACE: 'place',
  OUTCODE: 'outcode',
};
